/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { GetAllActiveStudiesResponse } from '../models/GetAllActiveStudiesResponse';
import type { GetClinTrakStudyDataResponse } from '../models/GetClinTrakStudyDataResponse';
import type { GetPendingSitesResponse } from '../models/GetPendingSitesResponse';
import type { GetStudyComparisonDataResponse } from '../models/GetStudyComparisonDataResponse';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class ClinTrakStudyService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @returns GetAllActiveStudiesResponse
     * @throws ApiError
     */
    public clinTrakStudyGetAllActiveStudies(): Observable<Array<GetAllActiveStudiesResponse>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/clintrak/studies/activestudies',
        });
    }
    /**
     * @param studyId
     * @returns GetPendingSitesResponse
     * @throws ApiError
     */
    public clinTrakStudyGetPendingSites(
        studyId: number,
    ): Observable<Array<GetPendingSitesResponse>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/clintrak/studies/{studyId}/sites',
            path: {
                'studyId': studyId,
            },
        });
    }
    /**
     * @param pcsStudyId
     * @returns GetStudyComparisonDataResponse
     * @throws ApiError
     */
    public clinTrakStudyGetStudyComparisonDataByPcsStudyId(
        pcsStudyId: number,
    ): Observable<GetStudyComparisonDataResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/clintrak/studies/comparison/{pcsStudyId}',
            path: {
                'pcsStudyId': pcsStudyId,
            },
        });
    }
    /**
     * @param studyId
     * @returns GetClinTrakStudyDataResponse
     * @throws ApiError
     */
    public clinTrakStudyGetClinTrakStudyData(
        studyId: string,
    ): Observable<GetClinTrakStudyDataResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/clintrak/studies/data/{studyId}',
            path: {
                'studyId': studyId,
            },
        });
    }
}
